import { combineReducers } from "redux";
import { Practice } from "../types";
import { getFailureActionType, getSuccessActionType } from "../utils";
import {
  CHANGE_PRACTICE_STATUS_REQUEST,
  CHANGE_PRACTICE_WEIGHT_REQUEST,
  CREATE_PRACTICE_REQUEST,
  FETCH_PRACTICES_REQUEST,
  UPDATE_PRACTICE_REQUEST,
} from "./constants";
import { Action } from "./types";

function items(state: Practice[] = [], action: Action): Practice[] {
  switch (action.type) {
    case getSuccessActionType(FETCH_PRACTICES_REQUEST):
      return action.payload;

    case UPDATE_PRACTICE_REQUEST:
    case CHANGE_PRACTICE_STATUS_REQUEST:
    case CHANGE_PRACTICE_WEIGHT_REQUEST:
      return state.map((practice) =>
        practice.id === action.data.practiceId
          ? {
              ...practice,
              isFetching: true,
            }
          : practice
      );

    case getSuccessActionType(UPDATE_PRACTICE_REQUEST):
    case getSuccessActionType(CHANGE_PRACTICE_STATUS_REQUEST):
    case getSuccessActionType(CHANGE_PRACTICE_WEIGHT_REQUEST):
      return state.map((practice) =>
        practice.id === action.data.practiceId
          ? {
              ...action.payload,
              isFetching: false,
            }
          : practice
      );

    case getFailureActionType(UPDATE_PRACTICE_REQUEST):
    case getFailureActionType(CHANGE_PRACTICE_STATUS_REQUEST):
    case getFailureActionType(CHANGE_PRACTICE_WEIGHT_REQUEST):
      return state.map((practice) =>
        practice.id === action.data.practiceId
          ? {
              ...practice,
              isFetching: false,
            }
          : practice
      );

    case getSuccessActionType(CREATE_PRACTICE_REQUEST):
      return [...state, action.payload];

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_PRACTICES_REQUEST:
      return true;
    case getSuccessActionType(FETCH_PRACTICES_REQUEST):
    case getFailureActionType(FETCH_PRACTICES_REQUEST):
      return false;

    case CREATE_PRACTICE_REQUEST:
      return true;
    case getSuccessActionType(CREATE_PRACTICE_REQUEST):
    case getFailureActionType(CREATE_PRACTICE_REQUEST):
      return false;
    default:
      return state;
  }
}

export const practices = combineReducers({ items, isFetching });
